import { assign } from 'lodash';
import defaultConfig, {
  xAxisStyle,
  legendStyle,
  yAxisStyle,
  seriesStyle,
} from '../config';

import { computeAverage, getMaxIntByList, fenToYuan } from '@/common/number/';

export default {
  computed: {
    legend() {
      return [
        {
          name: '客户数',
          icon: 'circle',
        },
        {
          name: '消耗额',
          icon: 'circle',
        },
        {
          name: '消耗额环比',
          icon: 'line',
        },
      ];
    },

    xAxis() {
      return this.dataSource.map((item) => {
        return item.date;
      });
    },

    // 客户数
    num() {
      return this.dataSource.map((item) => {
        return item.num;
      });
    },

    // 消耗额
    cost() {
      return this.dataSource.map((item) => {
        return fenToYuan(item.cost);
      });
    },

    // 消耗额环比
    costRate() {
      return this.dataSource.map((item) => {
        return item.cost_rate ? parseFloat(item.cost_rate) : 0;
      });
    },

    // y轴 客户数
    yAxisNum() {
      const min = 0;
      const max = getMaxIntByList(this.num);
      const splitNumber = 5;

      return {
        min,
        max,
        splitNumber,
        interval: (max - min) / splitNumber,
        show: true,
      };
    },

    // y轴 消耗额
    yAxisCost() {
      const min = 0;
      const max = getMaxIntByList(this.cost);
      const splitNumber = 5;

      return {
        min,
        max,
        splitNumber,
        interval: (max - min) / splitNumber,
        show: true,
        axisLabel: {
          color: '#9CA6C0',
          fontFamily: 'DINPro-Medium, PingFang SC',
          formatter(params) {
            const { remainder, abbr } = computeAverage(params);
            return `${remainder}${abbr}`;
          },
        },
      };
    },

    // y轴 消耗额环比
    yAxisCostRate() {
      const min = Math.min.apply(null, this.costRate);
      const max = getMaxIntByList(this.costRate);
      const splitNumber = 5;
      return {
        min,
        max,
        splitNumber,
        interval: (max - min) / splitNumber,
        show: false,
      };
    },

    seriesNum() {
      return {
        name: '客户数',
        type: 'bar',
        yAxisIndex: 0,
        barWidth: 16,
        data: this.num,
      };
    },

    seriesCost() {
      return {
        name: '消耗额',
        type: 'bar',
        yAxisIndex: 1,
        barWidth: 16,
        data: this.cost,
      };
    },

    seriesCostRate() {
      return {
        name: '消耗额环比',
        type: 'line',
        yAxisIndex: 2,
        data: this.costRate,
      };
    },
  },

  methods: {
    getOption() {
      const defaultOption = {
        legend: assign({}, legendStyle, { data: this.legend }),
        xAxis: assign({}, xAxisStyle, { data: this.xAxis }),
        yAxis: [
          assign({}, yAxisStyle, this.yAxisNum),
          assign({}, yAxisStyle, this.yAxisCost),
          assign({}, yAxisStyle, this.yAxisCostRate),
        ],
        series: [
          assign({}, seriesStyle, this.seriesNum),
          assign({}, seriesStyle, this.seriesCost),
          assign({}, seriesStyle, this.seriesCostRate),
        ],
      };

      return {
        ...defaultConfig,
        ...defaultOption,
      };
    },
  },
};
